import { createUrlResolver } from '@seek/melways-sites';
import type React from 'react';

import type { ConfigOptions, ConfigUtils } from 'src/types';

import { ConfigContext } from '../useConfig';

export interface ConfigProviderProps {
  value: ConfigOptions;
}

export const ConfigProvider: React.FC<
  React.PropsWithChildren<ConfigProviderProps>
> = ({ value: config, children }) => {
  const urlResolver = createUrlResolver({
    site: config.site,
    language: config.locale,
    staging: config.environment === 'staging',
  });

  const configUtils: ConfigUtils = {
    urlResolver,
  };

  return (
    <ConfigContext.Provider value={{ ...config, ...configUtils }}>
      {children}
    </ConfigContext.Provider>
  );
};
